import { createSlice } from '@reduxjs/toolkit';

export interface reportPaletteState {
    visible: boolean;
}

export const filterSidebarSlice = createSlice({
    name: ' filterSidebar',
    initialState: {
        visible: false,
    } as reportPaletteState,
    reducers: {
        show: (state) => {
            state.visible = true;
        },
        hide: (state) => {
            state.visible = false;
        },
    },
});

export const { show, hide } = filterSidebarSlice.actions;

export default filterSidebarSlice.reducer;
